/** Images */
import { ReactComponent as HLine } from "../../assets/horizontal-line.svg";
import { ReactComponent as VLine } from "../../assets/vertical-line.svg";

/** MUI */
import {
    Box,
    Container,
    Grid2 as Grid,
    Typography,
} from "@mui/material";

/** Components */
import classes from "./howdoeswork.module.css";

const HowDoesWork = () => {
    return (
        <Box className={classes.howdoeswork}>
            <Box className={classes.svgcontainerV}>
                <VLine />
            </Box>
            <Container maxWidth="xl" disableGutters className={classes.containerHow}>
                <Typography variant="h1" color="secondary" className={classes.titleText}>
                    How does it work?
                </Typography>
                <Box className={classes.svgcontainer}>
                    <HLine />
                </Box>
                <Grid container spacing={{ xs: 2, md: 3, xxl: 4 }} className={classes.featuresContent}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography variant="h2" color="secondary" className={classes.paddingB}>
                            Automate
                        </Typography>
                        <Typography color="V003" variant="body1">
                            workflows to accurately extract information from invoices, bills, bank statements and
                            payments.
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography variant="h2" color="secondary" className={classes.paddingB}>
                            Approve
                        </Typography>
                        <Typography color="V003" variant="body1">
                            Noddok's suggestions to ensure records are registered with the same precision as you would
                            do.
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography variant="h2" color="secondary" className={classes.paddingB}>
                            Synchronize
                        </Typography>
                        <Typography color="V003" variant="body1">
                            transactions and files with the accounting software and ensure real-time data consistency.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default HowDoesWork;